import { ArrowIcon } from "../../../assets/icons";
import { Button } from "../../../components/button/button";

import { Text } from "../../../components/text/text";

import styles from "./cafeList.module.css"

export const CafeItem = ({ data, onClick }) => {
    return (
        <Button
            text={
                <div className={styles.cafe_info}>
                    <Text as="div" variant="body" className={styles.cafe_name} >
                        {data.name}
                    </Text>
                    <Text as="div" variant="body" className={styles.cafe_address} >
                        {data.address}
                    </Text>
                </div>
            }
            icon={<ArrowIcon />}
            type="secondary"
            onClick={onClick}
        />
    );
}